import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslocoModule } from '@ngneat/transloco';
//----------------------------------------------
import { ChargeGuestMealModal } from './charge-guest-meal.modal';

@NgModule({
  declarations: [ChargeGuestMealModal],
  imports: [CommonModule, IonicModule, TranslocoModule]
})
export class ChargeGuestMealModalModule {}
